'use client'

import { useGlobalSet } from '@/lib/store/useGlobal'
import { useEffect, useMemo } from 'react'
import { useWindowSize } from 'react-use'

export default function ClientEvent() {
  const { width } = useWindowSize()
  const setGlobal = useGlobalSet()
  // 判断是否移动端或平板
  const [isMobile, isTablet, isLg] = useMemo(() => {
    const userAgent = typeof navigator === 'object' ? navigator.userAgent : ''
    const isMobile = /mobile|android|iphone/.test(userAgent) || width < 768
    const isTablet = !isMobile && /ipad|tablet/.test(userAgent)
    const isLg = width >= 1024 // 判断是否大屏设备
    return [isMobile, isTablet, isLg]
  }, [width])

  useEffect(() => {
    setGlobal({ mobile: isMobile, tablet: isTablet, lg: isLg })
  }, [isMobile, isTablet, isLg, setGlobal])

  return null
}
